/* RYTM showcase carousel. Vanilla JS, no dependencies, safe for multiple instances per page. */
(function () {
  'use strict';

  var SWIPE_THRESHOLD = 40;

  function initInstance(root) {
    if (root.dataset.rytmCarouselInit === 'true') return;
    root.dataset.rytmCarouselInit = 'true';

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-rytm-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-rytm-dot]'));
    var prevBtn = root.querySelector('[data-rytm-prev]');
    var nextBtn = root.querySelector('[data-rytm-next]');
    if (slides.length < 2) return;

    var currentIndex = 0;

    function goTo(index) {
      currentIndex = (index + slides.length) % slides.length;

      slides.forEach(function (slide, i) {
        slide.setAttribute('aria-hidden', i === currentIndex ? 'false' : 'true');
      });

      dots.forEach(function (dot, i) {
        dot.setAttribute('aria-current', i === currentIndex ? 'true' : 'false');
      });
    }

    function next() { goTo(currentIndex + 1); }
    function prev() { goTo(currentIndex - 1); }

    if (prevBtn) prevBtn.addEventListener('click', prev);
    if (nextBtn) nextBtn.addEventListener('click', next);

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.index, 10) || 0);
      });
    });

    root.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        prev();
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        next();
      }
    });

    var touchStartX = null;
    var touchStartY = null;

    root.addEventListener('touchstart', function (event) {
      if (event.touches.length !== 1) return;
      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
    }, { passive: true });

    root.addEventListener('touchend', function (event) {
      if (touchStartX === null) return;
      var touch = event.changedTouches[0];
      var deltaX = touch.clientX - touchStartX;
      var deltaY = touch.clientY - touchStartY;
      touchStartX = null;
      touchStartY = null;

      if (Math.abs(deltaX) < SWIPE_THRESHOLD || Math.abs(deltaX) < Math.abs(deltaY)) return;
      if (deltaX < 0) {
        next();
      } else {
        prev();
      }
    }, { passive: true });

    goTo(0);
  }

  function initAll(context) {
    var scope = context || document;
    var instances = [];

    if (scope.matches && scope.matches('[data-rytm-carousel]')) {
      instances.push(scope);
    }
    if (scope.querySelectorAll) {
      Array.prototype.forEach.call(scope.querySelectorAll('[data-rytm-carousel]'), function (el) {
        instances.push(el);
      });
    }

    instances.forEach(initInstance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();